export default __webpack_public_path__ + "static/media/2023-brestovat-fatada.7386f0eb.jpg";